/*
  BillingsSummaryRequest.js - Handles Search for Billing Data
*/

// MODULES
import RequestRabbit from './RequestRabbit';

// CONFIGURATION
import config from '../Config';

const useBillingSummaryRequest = () => {
  /*
    Get Data for Date Range
  */
  const getData = async (monthValue, year, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/billing/report/summary?monthNum=${monthValue}&year=${year}`;
      const options = { method: 'GET' };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
      return [];
    }
  };

  return {
    getData,
  };
};

export default useBillingSummaryRequest;
